import React from 'react'
import Head from './Head';
function Imgexplore() {
  return (
    
    <div className="bg-dark">
      <Head/>
        <center className="bg-dark">
      <img  src="https://th.bing.com/th/id/OIP.hqgXmy-r13g-63xcvlz6AwHaE7?rs=1&pid=ImgDetMain"width="260px"height="260px"className="rounded-circle w-50 h-50"style={{height:"100%"}}/>
     
      <div className="bg-dark">
      <p style={{width:"70%",color:"white","font-family":"Monaco"}}>
        Hi you know iam very well.Importantly i am start a startup and you join with me,so please contact me and your are a team member and 
        we are a team.
        Thankyou for mainly open this web.
        
      </p>
      </div>
      </center>
    </div>
  )
}

export default Imgexplore
